import { Breadcrumb } from "antd";
import "./index.scss";

interface BreadcrumbComponentProps {
  items: string[];
}

function BreadcrumbComponent({ items }: BreadcrumbComponentProps) {
  const breadcrumbItems = items.map((item, index) => ({
    title: item,
    key: index, 
  }));

  return (
    <div className="bread-crumb">
      <span className="h2-semiBold">{items[0]}</span>
      <Breadcrumb
        items={breadcrumbItems.map((item, index) => ({
          title: item.title,
          ...(index === breadcrumbItems.length - 1 && { className: "current-page" })
        }))}
        style={{ margin: "5px 0 15px 0" }}
      />
    </div>
  );
}

export default BreadcrumbComponent;
